import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../utils/withRouter';
import Loader from '../../utils/Loader'
import { fill_action } from '../../actions/fillList_action';
import { clientNameActionId, sessionExpireMessage, tokenInavlidMessage } from '../../utils/constants';
import {
    myOrders_list_action,
} from "../../actions/myOrders_action/myOrders_action";
import Header from '../../common_components/Header';
import { toast, } from 'react-toastify';
import moment from 'moment';
import { Tab, Nav } from "react-bootstrap";
import Pagination from "../../utils/pagination";

class CheckList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            myOrderList: [],
            currentPage: 1,
            orderNo: '',
            client: '',
            currrentDate: '',
            clientName: "",
            clientNameList: [],
            tempClientList: [],
            isDisplayClientList: false,
        }
        this.updateItem = this.updateItem.bind(this)
    }

    componentDidMount() {
        if (JSON.parse(sessionStorage.getItem('UserLoginData')) == null) {
            console.log('log')
            setTimeout(() => {
                this.props.navigate('/login')
            }, 500);
        }
        setTimeout(() => {
            {
                sessionStorage.getItem("roleId") == 4 ?
                    this.props.navigate('/checkList') :
                    <></>
            }
        }, 10);
        console.log("sessionStorage.getItemroleId", sessionStorage.getItem("roleId"))
        this.getFillList(clientNameActionId, "");

        const todayDate = moment(new Date().toLocaleDateString(), "MM/DD/YYYY").format("DD/MM/YYYY")

        this.setState({ currrentDate: todayDate })

        this.setState({
            clientName: sessionStorage.getItem("searchClientName") != null ? sessionStorage.getItem("searchClientName") : ''
        })

        setTimeout(() => {
            this.getOrdersList()
        }, 100);
    }

    getFillList(value, userID) {
        this.setState({ isLoading: true });
        this.props
            .fill_action(value, userID == "" || userID == null ? null : userID)
            .then((data) => {
                if (data.error != 1) {
                    if (value == clientNameActionId) {
                        this.setState({
                            clientNameList: data.data,
                            tempClientList: data.data,
                        })
                    }
                }
            })
            .catch((e) => {
                console.log(e);
            });
    }

    // search city
    onClientSearch(e) {
        const { clientNameList, tempClientList } = this.state
        if (e.target.value != '') {
            var searchClientList = tempClientList.filter(data => {
                return (
                    data
                        .Client
                        .toLowerCase()
                        .includes(e.target.value.toLowerCase())
                )
            })
            this.setState({
                clientName: e.target.value,
                cityErr: '',
                tempClientList: searchClientList,
                isDisplayClientList: true
            })
        } else {
            this.setState({
                clientName: e.target.value,
                tempClientList: clientNameList,
                isDisplayClientList: false
            })
        }
    }

    // render city
    renderClientList() {
        const { tempClientList } = this.state
        return (
            <ul class="list-group pincode-drop" style={{ position: 'absolute', zIndex: 1 }}>
                {
                    tempClientList.length > 0 && tempClientList.map(data => (
                        <li class="list-group-item" key={Math.random()}
                            onClick={() => this.mainClientListData(data)}
                        >{data.Client}</li>
                    ))
                }
            </ul>
        )
    }

    mainClientListData(data) {
        this.setState({ clientName: data.Client, isDisplayClientList: false, })
    }

    handleClear() {
        this.setState({ clientName: '' })
        setTimeout(() => {
            this.getOrdersList()
        }, 100);
    }

    getOrdersList() {
        const { clientName, currrentDate } = this.state

        this.setState({ isLoading: true })
        this.props
            .myOrders_list_action('', '', '', '', clientName)
            .then((data) => {
                if (data.error != 1) {

                    const filterMyOrderList = data.data.filter(data => {
                        return data.DeliveryStatus == 'Confirmed' || data.DeliveryStatus == 'Delivered'
                    })

                    filterMyOrderList.map((data) => {
                        if (data.Is_NoDue == 0 && data.Is_PossessionSubmitted == 0 && data.Is_ExitSubmitted == 0 && data.Is_ExitPass == 0) {
                            data.Is_sortArray = ["No Due Certificate pending"]
                        } else if (data.Is_NoDue == 1 && data.Is_PossessionSubmitted == 0 && data.Is_ExitSubmitted == 0 && data.Is_ExitPass == 0) {
                            data.Is_sortArray = ["No Due certficated Generated"]
                        } else if (data.Is_NoDue == 1 && data.Is_PossessionSubmitted == 1 && data.Is_ExitSubmitted == 0 && data.Is_ExitPass == 0) {
                            data.Is_sortArray = ["Possesion submitted", <br />, "No Due certficated Generated"]
                        } else if (data.Is_NoDue == 1 && data.Is_PossessionSubmitted == 1 && data.Is_ExitSubmitted == 1 && data.Is_ExitPass == 0) {
                            data.Is_sortArray = ["Exit Submitted", <br />, "Possesion submitted", <br />, "No Due certficated Generated"]
                        } else {
                            data.Is_sortArray = ["Exit Pass Issued", <br />, "Exit Submitted", <br />, "Possesion submitted", <br />, "No Due certficated Generated"]
                        }
                    })

                    // filterMyOrderList.map((data) => {
                    //     data.Is_sortArray = [
                    //         data.Is_NoDue != 0 ? 5 : 1,
                    //         data.Is_PossessionSubmitted != 0 ? 4 : 1,
                    //         data.Is_ExitSubmitted != 0 ? 3 : 1,
                    //         data.Is_ExitPass != 0 ? 2 : 1,
                    //     ]
                    // })

                    // filterMyOrderList.sort((a, b) => {
                    //     const sumA = a.Is_sortArray.reduce((acc, val) => acc - val, 0);
                    //     const sumB = b.Is_sortArray.reduce((acc, val) => acc - val, 0);

                    //     return sumA - sumB;
                    // });

                    console.log("sortArray-------------1111", filterMyOrderList)
                    this.setState({ myOrderList: filterMyOrderList, isLoading: false })


                    // const list = []
                    // filterMyOrderList != '' ? filterMyOrderList.map((item) => {
                    //     var splitDate = item.BookingDate != null ? item.BookingDate.split(',') : null
                    //     var splitDate2 = splitDate !=null ? splitDate[0] : null
                    //     if (splitDate2 == '27/09/2023') {
                    //         list.push(item)
                    //     }
                    // }) : <></>
                    // this.setState({ myOrderList: list })

                }
                else {
                    if (data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage) {
                        //after session expire.....................
                        sessionStorage.clear()
                        this.props.navigate('/login')
                        setTimeout(() => {
                            toast.error(data.msg, {
                                position: "top-center",
                                theme: "colored",
                                autoClose: 3000,
                                hideProgressBar: true,
                            });
                        }, 500);
                    } else {
                        this.setState({ isLoading: false })
                        toast.error(data.data, {
                            theme: 'colored',
                            autoClose: 3000,
                            hideProgressBar: true,
                        })
                    }
                }
                sessionStorage.setItem("searchClientName", clientName)
            })
            .catch((e) => {
                console.log(e);
            });
    }



    updateItem(item) {
        this.setState({ currentPage: item });
    }

    viewCheckList(
        OrderID,
        OrderNo,
        ClientID,
        DeliveryStatus,
        ProformaInvoiceID,
        ProformaInvoice_No,
        CompanyName,
        PrimaryEmailID,
        CenterID
    ) {
        this.props.navigate("/checkList_au", {
            state: {
                OrderID: OrderID,
                OrderNo: OrderNo,
                ClientID: ClientID,
                DeliveryStatus: DeliveryStatus,
                ProformaInvoiceID: ProformaInvoiceID,
                ProformaInvoice_No: ProformaInvoice_No,
                CompanyName: CompanyName,
                PrimaryEmailID: PrimaryEmailID,
                CenterID: CenterID,
            },
        });
    }

    record(orderList) {
        console.log("orderList-------", orderList)
        return (

            <table class="table table-bordered table-striped" id="dashboard-table">
                <thead>
                    <tr>
                    <th>APPLICATION NO</th>
                    <th>ORDER NUMBER</th>
                        <th>BOOKING DATE</th>
                        <th>ORGANIZER NAME</th>
                        <th>ITME CENTER</th>
                        <th>EVENT DATE</th>
                        <th style={{ width: '200px' }}>TYPE OF EVENT</th>
                        {/* <th>ORDER AMOUNT</th> */}
                        <th style={{ width: '200px' }}>STATUS</th>
                        <th className="text-right" style={{ width: '5%' }}>
                            ACTION
                        </th>
                    </tr>
                </thead>
                <tbody id="myTable">
                    {
                        orderList != '' && orderList != null ? (
                            orderList.map((data, i) => (
                                <tr>
                                    <td>{data.OrderID}</td>
                                    <td>{data.OrderNo}</td>
                                    <td className="text-left">
                                        {data.OrderDate
                                            ? moment(data.OrderDate).format("DD-MM-YYYY")
                                            : null}
                                    </td>
                                    <td>{data.CompanyName}</td>
                                    <td>{data.ItmeCenter}</td>
                                    <td
                                        style={{
                                            overflowX: "hidden",
                                            maxWidth: "4rem",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {data.BookingDate}
                                    </td>
                                    <td style={{ maxWidth: "5rem" }}>{data.TypeOfEvent}</td>
                                    {/* <td className="text-right">
                                        {" "}
                                        {data.OrderAmount !== null
                                            ? data.OrderAmount.toLocaleString("en-IN")
                                            : null}{" "}
                                    </td> */}
                                    {
                                        data.Is_sortArray[0] == 'No Due Certificate pending' ?
                                            <td className="text-left" style={{ width: '14%' }}>
                                                <span className='badge_soft_danger p-1'>{data.Is_sortArray}</span>
                                            </td> :
                                            <td className="text-left" style={{ width: '14%' }}>
                                                <span className='badge_soft_success p-1'>{data.Is_sortArray}</span>
                                            </td>
                                    }
                                    {/* <td className="text-left">
                                        {
                                            data.Is_NoDue == 0 ?
                                                <span className="badge_soft_danger"
                                                >
                                                    No Due Certificate pending
                                                </span> :
                                                <>
                                                    {
                                                        data.Is_NoDue == 1 && data.Is_PossessionSubmitted == 0 ? <span className="badge_soft_success"
                                                        >
                                                            No Due Certificate issued
                                                        </span> :

                                                            <>
                                                                {
                                                                    <>
                                                                        {
                                                                            data.Is_PossessionSubmitted == 1 && data.Is_ExitSubmitted == 0 ?
                                                                                <span className="badge_soft_success">
                                                                                    Possession submitted
                                                                                </span> :
                                                                                <>
                                                                                    {
                                                                                        data.Is_ExitSubmitted == 1 && data.Is_ExitPass == 0 ?
                                                                                            <span className="badge_soft_success" >
                                                                                                Exit submitted
                                                                                            </span> :
                                                                                            <span className="badge_soft_success" >
                                                                                                Exit Pass issued
                                                                                            </span>
                                                                                    }
                                                                                </>
                                                                        }
                                                                    </>
                                                                }
                                                            </>
                                                    }
                                                </>
                                        }
                                    </td> */}
                                    <td className="text-center">
                                        <a
                                            title="View Order"
                                            class="btn btn-sm padding_0"
                                            onClick={() =>
                                                this.viewCheckList(
                                                    data.OrderID,
                                                    data.OrderNo,
                                                    data.ClientID,
                                                    data.DeliveryStatus,
                                                    data.ProformaInvoiceID,
                                                    data.ProformaInvoice_No,
                                                    data.CompanyName,
                                                    data.PrimaryEmailID,
                                                    data.CenterID
                                                )
                                            }
                                        >
                                            <i class="fa fa-eye action_btn_table"></i>
                                        </a>

                                        {/* <a
                                            title="Edit Order"
                                            className="btn btn-sm padding_0"
                                            data-toggle="modal"
                                            data-target="#editOrder"
                                            onClick={() =>
                                                this.onEditNavigate(
                                                    data.OrderID,
                                                    data.OrderNo,
                                                    data.ClientID,
                                                    data.DeliveryStatus,
                                                    data.ProformaInvoiceID,
                                                    data.ProformaInvoice_No,
                                                    data.CompanyName,
                                                    data.PrimaryEmailID
                                                )
                                            }
                                        >
                                            <i className="fa fa-edit action_btn_table"></i>
                                        </a> */}
                                        {/* <a
                                            title="Cancel Order"
                                            className="btn btn-sm delete_record"
                                            onClick={() =>
                                                this.deleteModalShow(
                                                    data.OrderID,
                                                    data.OrderNo,
                                                    data.CompanyName,
                                                    data.PrimaryEmailID,
                                                    data.RoleID,
                                                    data.OrderAmount,
                                                    data.BookingDate,
                                                    data.CancellationReasonID,
                                                    data.cancelNote
                                                )
                                            }
                                        >
                                            <i className="fa fa-trash action_btn_table" />
                                        </a> */}
                                    </td>
                                </tr>
                            ))
                        ) : (<tr><td colSpan={12} className='text-center'>Record not found</td></tr>)
                    }
                </tbody>
            </table>
        )
    }

    render() {

        const { isLoading, myOrderList, currentPage, isDisplayClientList, clientName, currrentDate } = this.state

        const recordsPerPage = 10
        const indexOfLastRecord = currentPage * recordsPerPage;
        const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
        // Records to be displayed on the current page
        const currentRecords = myOrderList.slice(indexOfFirstRecord, indexOfLastRecord);
        const nPages = Math.ceil(myOrderList.length / recordsPerPage)

        return (
            <>

                {isLoading ?
                    <Loader></Loader> : false
                }
                <>
                    <main id="main">
                        <Header data={[18]} />
                        <section style={{ marginTop: 115 }}>
                            <div className="container-fluid">
                                <div className="page-header">
                                    <h4 className="page-title">Check List</h4>
                                </div>
                                <div class="search_accordion search_card">
                                    <div class="panel-group" id="accordion">
                                        <div class="panel panel-default">
                                            {/* <div
                                                    className="panel-heading accordion-toggle collapsed"
                                                    data-toggle="collapse"
                                                    data-parent="#accordion"
                                                    data-target="#collapseOne"
                                                    aria-expanded={isAccordionExpanded}
                                                    onClick={() =>
                                                        this.setState({
                                                            isAccordionExpanded: !isAccordionExpanded,
                                                        })
                                                    }
                                                >
                                                    <h4 class="panel-title">Search</h4>

                                                    <div class="searched_items">
                                                        <h5>Client Name  :</h5>
                                                        <h5>Currrent Date:</h5>
                                                    </div>

                                                </div> */}
                                            <div
                                                id="collapseOne"
                                                className={`panel-collapse collapse show`}
                                            >
                                                <div class="panel-body">
                                                    <div class="row mr_0">
                                                        <div class="col-md-2">
                                                            <div class="form-group mb-3">
                                                                <label>Organizer Name<span style={{ color: 'red' }}>*</span></label>
                                                                <input
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="validationCustom03"
                                                                    value={clientName}
                                                                    onChange={(e) => this.onClientSearch(e)}
                                                                    autocomplete="off"
                                                                />
                                                                {isDisplayClientList && this.renderClientList()}
                                                            </div>
                                                        </div>
                                                        {/* <div class="col-md-2">
                                                            <div class="form-group">
                                                                <label>Currrent Date</label>
                                                                <input type="text" class="form-control"
                                                                    disabled={true}
                                                                    value={currrentDate}
                                                                    onChange={(e) => this.setState({ currrentDate: e.target.value })}
                                                                />
                                                            </div>
                                                        </div> */}
                                                        <div class="col-md-2">
                                                            <label>&nbsp;</label>
                                                            <div class="d-flex">
                                                                <a class="btn btn-primary search_btn" onClick={() => this.getOrdersList()}>Search</a>
                                                                <a class="btn btn-primary search_btn ml-2" onClick={() => this.handleClear()}>Clear</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div>
                                    <div className="row mr_0">
                                        <div className="col-md-12 padding_0">
                                            <Tab.Container defaultActiveKey="all">
                                                <Nav
                                                    variant="tabs"
                                                    className="nav nav-tabs nav-tabs-custom nav-success mb-3"
                                                    role="tablist"
                                                >
                                                    <Nav.Item>
                                                        <Nav.Link
                                                            eventKey="Confirmed"
                                                            onClick={() => this.setState({ currentPage: 1 })}
                                                        >
                                                            <i className="ri-check-double-line me-1 align-bottom" />{" "}
                                                            Confirmed
                                                        </Nav.Link>
                                                    </Nav.Item>

                                                    <div class="custom_table">
                                                        <div class="hack1">
                                                            <div class="hack2">
                                                                {this.record(currentRecords)}
                                                                {myOrderList.length > 0 ? <Pagination
                                                                    nPages={nPages}
                                                                    currentPage={currentPage}
                                                                    setCurrentPage={this.updateItem} /> : <></>}
                                                            </div>
                                                        </div>
                                                    </div>

                                                </Nav>
                                            </Tab.Container>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            {/* </div> */}
                        </section>
                    </main>
                </>

            </>
        )
    }
}


export default withRouter(connect(null, { fill_action, myOrders_list_action })(CheckList));